import { Collapse, IconButton } from '@material-ui/core'
import { ChevronRight } from '@material-ui/icons'
import { last } from 'lodash'
import { useEffect, useState } from 'react'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { signDocument } from '../../../actions/documentActions'
import { markDocumentAsSigned } from '../../../actions/projectActions'
import customCircleCheck from '../../../assets/img/icons/ic-check-circle.png'
import DocumentView from '../../DocumentView/DocumentView'

interface Props {
  noCollapse: boolean
}

const SignAcceptanceCriteria = ({ noCollapse }: Props) => {
  const dispatch = useDispatch()

  const { project }: { project: Project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { success: docSignedSuccess } = useSelector(
    (state: RootStateOrAny) => state.projectDocumentSigned
  )
  const [documentIsSigned, setDocumentIsSigned] = useState<
    boolean | undefined | null
  >(
    project.acceptanceCriteria
      ? last(project.acceptanceCriteria)?.isSigned
      : undefined
  )
  const [expanded, setExpanded] = useState(!documentIsSigned || noCollapse)
  const [showDocument, setShowDocument] = useState(false)

  useEffect(() => {
    setShowDocument(true)
    dispatch(signDocument(project))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    if (docSignedSuccess) {
      setExpanded(false)
    }
  }, [docSignedSuccess, dispatch, project])

  const handlemarkDocumentAsSigned = () => {
    dispatch(markDocumentAsSigned(project._id))
    setDocumentIsSigned(true)
  }

  return (
    <>
      <div className="flex align-center p-t-24 p-b-24 space-between">
        <div className="flex align-center">
          {!noCollapse && (
            <IconButton
              disabled={true}
              aria-expanded={expanded}
              aria-label="show more"
              className={`m-r-10 ${expanded ? 'rotate' : ''}`}
            >
              <ChevronRight />
            </IconButton>
          )}
          <div>
            <h2 className="m-b-0 fs20">Sign service agreement</h2>
          </div>
        </div>
        {documentIsSigned && (
          <div className="signed text-right">
            <img
              src={customCircleCheck}
              alt="Circle Check"
              style={{ width: 14 }}
            />{' '}
            Signed
          </div>
        )}
      </div>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {showDocument && !documentIsSigned && (
          <DocumentView onSign={handlemarkDocumentAsSigned} />
        )}
      </Collapse>
    </>
  )
}

export default SignAcceptanceCriteria
